module.exports = __webpack_public_path__ + "img/zm.f6c0ef98.svg";